export const cssToFramerMotionCubicBezier = (cssCubicBezier: string) => {
  const [x1, y1, x2, y2] = cssCubicBezier
    .replace('cubic-bezier(', '')
    .replace(')', '')
    .split(',')
    .map(Number)
  return [x1, y1, x2, y2]
}
export const cssToFramerMotionDuration = (cssDuration: string) => {
  const [value, unit] = cssDuration.split(/(ms|s)/)
  if (unit === 'ms') {
    return Number(value) / 1000
  }
  return Number(value)
}
